/**
 * Cached system prompts for ask(). Invalidated when outline or tools change.
 */

import type { PageOutline } from '../types.js';
import { outlineToMarkdown, outlineToMarkdownQuick } from '../core/context.js';
import { buildQuickSystemPrompt, buildSystemPrompt } from '../llm/manual-tool-loop.js';
import { listTools } from '../tools/registry.js';

interface PromptCacheEntry {
  outlineRef: PageOutline;
  promptBase: string;
  toolsSig: string;
  outlineMd: string;
  outlineMdQuick: string;
  quickSystem: string;
  fullSystem: string;
}

let cache: PromptCacheEntry | null = null;

function toolsSignature(): string {
  return listTools()
    .map(({ fullName }) => fullName)
    .sort()
    .join(',');
}

export function invalidatePromptCache(): void {
  cache = null;
}

export function getCachedPrompts(
  outline: PageOutline,
  promptBase: string
): { quickSystem: string; fullSystem: string; outlineMd: string; outlineMdQuick: string } {
  const toolsSig = toolsSignature();
  if (
    cache &&
    cache.outlineRef === outline &&
    cache.promptBase === promptBase &&
    cache.toolsSig === toolsSig
  ) {
    return {
      quickSystem: cache.quickSystem,
      fullSystem: cache.fullSystem,
      outlineMd: cache.outlineMd,
      outlineMdQuick: cache.outlineMdQuick,
    };
  }

  const outlineMd = outlineToMarkdown(outline);
  const outlineMdQuick = outlineToMarkdownQuick(outline);
  const quickSystem = buildQuickSystemPrompt(promptBase + '\n\n' + outlineMdQuick);
  const fullSystem = buildSystemPrompt(promptBase + '\n\n' + outlineMd);

  cache = {
    outlineRef: outline,
    promptBase,
    toolsSig,
    outlineMd,
    outlineMdQuick,
    quickSystem,
    fullSystem,
  };

  return { quickSystem, fullSystem, outlineMd, outlineMdQuick };
}
